<template>
  <nav
    v-if="total > 1"
    aria-label="Page navigation">
    <ul class="pagination justify-content-center mb-0">
      <li
        v-if="current > 1"
        class="page-item">
        <button
          type="button"
          class="page-link"
          @click="go(current - 1)">
          <span aria-hidden="true">&laquo;</span>
          <span class="sr-only">Previous</span>
        </button>
      </li>
      <li
        v-else
        class="page-item disabled">
        <span
          class="page-link"
          aria-hidden="true">&laquo;</span>
        <span class="sr-only">Previous</span>
      </li>
      <li
        v-for="(page, key) in range"
        :class="{ active: page === current }"
        :key="key"
        class="page-item">
        <button
          type="button"
          class="page-link"
          @click="go(page)">
          {{ page }}
        </button>
      </li>
      <li
        v-if="current < total"
        class="page-item">
        <button
          type="button"
          class="page-link"
          @click="go(current + 1)">
          <span aria-hidden="true">&raquo;</span>
          <span class="sr-only">Next</span>
        </button>
      </li>
      <li
        v-else
        class="page-item disabled">
        <span
          class="page-link"
          aria-hidden="true">&raquo;</span>
        <span class="sr-only">Next</span>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'BasePagination',

  props: {
    current: { default: 1, required: true },
    show: { default: 7 },
    total: { default: 0, required: true }
  },

  computed: {
    range () {
      const index = this.current - 1
      const range = this.$_.range(1, this.total + 1)
      let offset = 0
      if (this.total > this.show) {
        offset = Math.max(0, index - Math.floor(this.show / 2))
        offset += Math.min(0, this.total - (offset + this.show))
      }
      return range.slice(offset, (offset + this.show))
    }
  },

  methods: {
    go (page) {
      this.$emit('go', page)
    }
  }
}
</script>
